import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';
import { omit, isEqual } from 'lodash-es';

export function passwordValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const password = control.value;

    if (!password) return null;

    return password.length < 8 ||
      !password.match(/[a-z]/g) ||
      !password.match(/[A-Z]/g) ||
      !password.match(/[0-9]/g) ||
      !password.match(/[^\w]/g)
      ? { invalid: true }
      : null;
  };
}

export function passwordMatchValidator(passwordControlName: string, repeatPasswordControlName: string): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const passwordControl = control.get(passwordControlName);
    const repeatPasswordControl = control.get(repeatPasswordControlName);

    if (!passwordControl?.value || !repeatPasswordControl?.value) return null;

    if (passwordControl.value !== repeatPasswordControl.value) {
      passwordControl.setErrors({ ...passwordControl.errors, passwordMismatch: true });
      repeatPasswordControl.setErrors({ ...repeatPasswordControl.errors, passwordMismatch: true });
      return { passwordMismatch: true };
    } else {
      const newPasswordControlErrors = omit(passwordControl.errors, 'passwordMismatch');
      if (isEqual(newPasswordControlErrors, {})) {
        passwordControl.setErrors(null);
      } else {
        passwordControl.setErrors(newPasswordControlErrors);
      }
      const newRepeatPasswordControlErrors = omit(repeatPasswordControl.errors, 'passwordMismatch');
      if (isEqual(newRepeatPasswordControlErrors, {})) {
        repeatPasswordControl.setErrors(null);
      } else {
        repeatPasswordControl.setErrors(newRepeatPasswordControlErrors);
      }
      return null;
    }
  };
}
